import CaptivePortalGuestProcessing from './CaptivePortalGuestProcessing';

export default CaptivePortalGuestProcessing;
